import StoreSelect from '@/components/storeSelect'
export default {
  components: {
    StoreSelect
  },
  props: {
    exportVisible: {
      type: Boolean,
      default: false
    },
    activeName: {
      type: String,
      default: 'guide'
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > new Date().setMonth(new Date().getMonth() - 1)
        }
      },
      exportParams: {
        monthRange: [], //导出日期
        type: '导购业绩' //导出类型：导购业绩 or 社群业绩
      },
      storeVisible: false, //选择门店的对话框展示
      selectStoreData: [], //选择门店数据
      exportList: [], //导出列表
      storeIds: -1, //选择门店的id
      listParams: {
        type: 1, //需要查询的模块标识  [导购：1] |默认1
        files_type: 1, //所查询的导购模块下的文件类别 [1:业绩excel  2:导购码zip] 3:社群统计Excel|默认1
        page: 1,
        page_size: 5
      },
      total_count: 0,
      createLoading: false,
      chatIds: -1, //选择社群的id
      communityVisible: false, //选择社群的对话框展示
      selectCommunityData: [] //选择社群数据
    }
  },
  watch: {
    exportVisible (newVal) {
      if (newVal) {
        let type = '导购业绩'
        if (this.activeName === 'guide') {
          type = '导购业绩'
        } else {
          type = '社群业绩'
        }
        this.exportParams = {
          monthRange: [],
          type
        }
        this.selectStoreData = []
        this.exportList = []
        this.storeIds = -1
        this.getExportList()
      }
    }
  },
  methods: {
    //重置门店选择
    clearStore () {
      this.selectStoreData = []
      this.storeNum = ''
      this.params.store_bn = []
      this.params.store_id = ''
    },

    // 选择店铺数据
    chooseStore (selectdata, storeids) {
      this.selectStoreData = selectdata
      this.params.store_id = storeids
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
    },
    // 选择店铺
    selectStore () {
      this.storeVisible = true
    },
    // 关闭店铺
    closeStoreDialog () {
      this.storeVisible = false
    },

    // 日期查询
    dateChange (value) {
      //this.params.dateValue = value
      this.params.start_date = value ? value[0] : ''
      this.params.end_date = value ? value[1] : ''
    },

    // 导出报表
    handleExport () {
      this.exportDialogVisible = true
    }
  }
}
